<template>
  <div>
    <el-alert
      title="按日/班次/工厂编制人员排岗（草稿→批准）。产线作业须指定产线。"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.assignmentCode" clearable placeholder="单号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.shiftId" clearable filterable placeholder="班次" style="width:140px">
        <el-option v-for="s in shiftOptions" :key="s.shiftId" :label="s.shiftName" :value="s.shiftId" />
      </el-select>
      <el-select v-model="query.factoryId" clearable filterable placeholder="工厂" style="width:140px">
        <el-option v-for="f in factoryOptions" :key="f.factoryId" :label="f.factoryName" :value="f.factoryId" />
      </el-select>
      <el-select v-model="query.assignmentState" clearable placeholder="状态" style="width:110px">
        <el-option label="草稿" value="00" />
        <el-option label="已批准" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新建</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="assignmentCode" label="单号" width="180" />
      <el-table-column prop="startDate" label="日期" width="120" />
      <el-table-column prop="shiftName" label="班次" width="120" />
      <el-table-column prop="factoryName" label="工厂" min-width="140" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.assignmentState === '01' ? 'success' : 'info'">
            {{ row.assignmentState === '01' ? '已批准' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="240" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.assignmentId, true)">查看</el-button>
          <el-button v-if="row.assignmentState === '00'" type="text" @click="openEdit(row.assignmentId)">修改</el-button>
          <el-button v-if="row.assignmentState === '00'" type="text" @click="doAccept(row)">批准</el-button>
          <el-button
            v-if="row.assignmentState === '00'"
            type="text"
            style="color:#ef4444"
            @click="doDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="980px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="单号">
              <el-input v-model="form.assignmentCode" placeholder="留空自动生成" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="日期" prop="startDate">
              <el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班次" prop="shiftId">
              <el-select v-model="form.shiftId" filterable style="width:100%">
                <el-option v-for="s in shiftOptions" :key="s.shiftId" :label="s.shiftName" :value="s.shiftId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工厂" prop="factoryId">
              <el-select v-model="form.factoryId" filterable style="width:100%">
                <el-option v-for="f in factoryOptions" :key="f.factoryId" :label="f.factoryName" :value="f.factoryId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
          </el-col>
        </el-row>
        <div style="margin:8px 0" v-if="!readonly">
          <el-button type="primary" size="mini" @click="addLine">添加人员</el-button>
        </div>
        <el-table :data="form.lineList" border size="small">
          <el-table-column label="员工" min-width="180">
            <template slot-scope="s">
              <el-select v-model="s.row.staffId" filterable size="mini" style="width:100%" :disabled="readonly">
                <el-option
                  v-for="st in staffOptions"
                  :key="st.staffId"
                  :label="(st.staffNumber || '') + ' / ' + (st.staffName || '')"
                  :value="st.staffId"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="岗位类型" width="140">
            <template slot-scope="s">
              <el-select v-model="s.row.occupationType" size="mini" style="width:100%" :disabled="readonly">
                <el-option label="产线作业" value="01workOnLine" />
                <el-option label="其他任务" value="02otherCase" />
                <el-option label="病假" value="03sickLeave" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="产线" min-width="160">
            <template slot-scope="s">
              <el-select
                v-model="s.row.productionLineId"
                filterable
                clearable
                size="mini"
                style="width:100%"
                :disabled="readonly || s.row.occupationType !== '01workOnLine'"
              >
                <el-option v-for="l in lineOptions" :key="l.lineId" :label="l.lineName" :value="l.lineId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="说明" min-width="140">
            <template slot-scope="s"><el-input v-model="s.row.description" size="mini" :disabled="readonly" /></template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" width="70" align="center">
            <template slot-scope="s">
              <el-button type="text" size="mini" @click="form.lineList.splice(s.$index, 1)">删</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listAssignmentToShift, getAssignmentToShift, saveAssignmentToShift,
  updateAssignmentToShift, deleteAssignmentToShift, acceptAssignmentToShift
} from '../../api/assignmentToShift'
import { selectShift } from '../../api/shift'
import { selectFactory } from '../../api/factory'
import { selectStaff } from '../../api/staff'
import { selectProductionLine } from '../../api/productionLine'

function emptyForm() {
  return {
    assignmentId: '', assignmentCode: '', startDate: '', shiftId: '', factoryId: '', remark: '',
    lineList: []
  }
}

export default {
  name: 'AssignmentToShiftPage',
  components: { ListPagination },
  data() {
    return {
      query: { assignmentCode: '', shiftId: '', factoryId: '', assignmentState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, readonly: false, saving: false, form: emptyForm(),
      rules: {
        startDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
        shiftId: [{ required: true, message: '请选择班次', trigger: 'change' }],
        factoryId: [{ required: true, message: '请选择工厂', trigger: 'change' }]
      },
      shiftOptions: [], factoryOptions: [], staffOptions: [], lineOptions: []
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看班次任务'
      return this.form.assignmentId ? '修改班次任务' : '新建班次任务'
    }
  },
  created() {
    this.loadLookups()
    this.load()
  },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    loadLookups() {
      selectShift().then(res => { this.shiftOptions = res.data || [] }).catch(() => {})
      selectFactory().then(res => { this.factoryOptions = res.data || [] }).catch(() => {})
      selectStaff().then(res => { this.staffOptions = res.data || [] }).catch(() => {})
      selectProductionLine().then(res => { this.lineOptions = res.data || [] }).catch(() => {})
    },
    load() {
      this.loading = true
      listAssignmentToShift({
        currentPage: this.page, pageSize: this.pageSize,
        assignmentCode: this.query.assignmentCode,
        shiftId: this.query.shiftId,
        factoryId: this.query.factoryId,
        assignmentState: this.query.assignmentState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id, readonly) {
      this.readonly = !!readonly
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) {
        this.addLine()
        return
      }
      getAssignmentToShift(id).then(res => {
        const row = res.data || {}
        this.form = Object.assign(emptyForm(), row)
        if (!this.form.lineList) this.form.lineList = []
      })
    },
    addLine() {
      if (!this.form.lineList) this.form.lineList = []
      this.form.lineList.push({
        staffId: '', occupationType: '01workOnLine', productionLineId: '', description: ''
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (!(this.form.lineList || []).length) {
          this.$message.warning('请添加人员')
          return
        }
        this.saving = true
        const req = this.form.assignmentId
          ? updateAssignmentToShift(this.form)
          : saveAssignmentToShift(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    doAccept(row) {
      this.$confirm('批准后不可再改，继续？', '提示', { type: 'warning' }).then(() => {
        acceptAssignmentToShift(row.assignmentId).then(() => {
          this.$message.success('已批准')
          this.load()
        })
      }).catch(() => {})
    },
    doDelete(row) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteAssignmentToShift([row.assignmentId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
